<template>
  <div id="app">
    <div class="container mt-3">
      <div class="row">
        <div class="col">
          <h1 class="text-muted">Ankieta</h1>
          <p class="lead">Odpowiedz na następujące pytania:</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div v-if="!isCompleted">
            <QuestionComponent
              :question="currentQuestion"
              :current-question-number="currentQuestionId"
              :number-of-questions="numberOfQuestions"
              v-on:question-answered="nextQuestion"
            ></QuestionComponent>
          </div>
          <div v-else>
            <div class="card mt-3">
              <div class="card-header">
                Dziękuję!
              </div>
              <div class="card-body">
                <p class="lead">Dziękujemy za wypełnienie ankiety</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import QuestionComponent from './components/QuestionComponent'

export default {
  name: 'app',
  
  components: {
    'QuestionComponent': QuestionComponent
  },

  data: function() {
    return {
      currentQuestionId: 1,

      // Handling question path
      currentQuestionPathId: 0,
      questionPath: [1, 2, 3, 4, 5, 6, 7, 8],

      // Question database
      questions: [
        {
          id: 1,
          question: 'Które spośród wymienionych obszarów branży IT będą się najbardziej rozwijać w najbliższej przyszłości?',
          answers: [
            'Automatyzacja / robotyzacja',
            'Big Data/ analytics',
            'Cloud',
            'Cybersecurity',
            'Drukowanie 3D',
            'Internet of Things',
            'Mobility',
            'Social technology',
            'Inne'
          ]
        },
        {
          id: 2,
          question: 'Czy jesteś zainteresowany problematyką Cyberbezpieczeństwa?',
          answers: [
            'Tak',
            'Nie',
            'Nie wiem / Trudno powiedzieć'
          ]
        },
        {
          id: 3,
          question: 'Czy w Twojej opinii wiedza na temat Cyberbezpieczeństwa stanowi atut w trakcie poszukiwania pracy?',
          answers: [
            'Zdecydowanie tak',
            'Raczej tak',
            'Ani tak, ani nie',
            'Raczej nie',
            'Zdecydowanie nie'
          ]
        },
        {
          id: 4,
          question: 'Czy w ciągu ostatnich 12-tu miesięcy ukończyłeś kursy, szkolenia w zakresie Cyberbezpieczeństwa?',
          answers: [
            'Tak',
            'Nie',
            'Nie wiem / trudno powiedzieć'
          ]
        },
        {
          id: 5,
          question: 'Jeśli otrzymasz gwarancję pracy po ukończeniu szkolenia z Cyberbezpieczeństwa z minimalnym wynagrodzeniem 5 000 zł, to czy zapłaciłbyś 19 000 zł za szkolenie?',
          answers: [
            'Tak',
            'Nie',
            'Tak, jeśli wynagrodzenie byłoby większe',
            'Tak, jeśli czesne byłoby niższe'
          ]
        },
        {
          id: 6,
          question: 'Jeśli otrzymasz gwarancję pracy po odbyciu szkolenia z Cyberbezpieczeństwa z minimalnym  wynagrodzeniem 6 000 zł, to czy zapłaciłbyś 23 000zł za szkolenie?',
          answers: [
            'Tak',
            'Nie',
            'Tak, jeśli wynagrodzenie byłoby większe',
            'Tak, jeśli czesne byłoby niższe'
          ]
        },
        {
          id: 7,
          question: 'Wolisz naukę stacjonarną, czy zdalną z Twojego domu?',
          answers: [
            'Stacjonarną',
            'Zdalną (online)',
            'Mieszaną'
          ]
        },
        {
          id: 8,
          question: 'Wolałbyś się szkolić w zakresie ofensywnego bezpieczeństwa (bycia etycznym hackerem), czy defensywnego bezpieczeństwa?',
          answers: [
            'Ofensywnego',
            'Defensywnego',
            'Bez znaczenia'
          ]
        }
      ],
      
      isCompleted: false,
    }
  },

  methods: {
    nextQuestion: function() {
      const length = this.$data.questionPath.length - 1;

      if (this.$data.currentQuestionPathId < length) {
        this.$data.currentQuestionPathId += 1;
      } else {
        this.$data.isCompleted = true;
      }

      const id = this.$data.questionPath[this.$data.currentQuestionPathId];
      this.$data.currentQuestionId = id;
    }
  },

  computed: {
    currentQuestion: function() {
      return this.$data.questions.filter(question => question.id === this.$data.currentQuestionId)[0];
    },
    numberOfQuestions: function() {
      return this.$data.questions.length;
    },
    matchingApp: function() {
      return this.$data.matchingApps[Math.floor(Math.random() * this.$data.matchingApps.length)]
    }
  }
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

h1 { font-size: 1.5rem; }
h2 { font-size: 1.3rem; }
h3 { font-size: 1.1rem; }
</style>
